/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type UnstakeMutationVariables = Types.Exact<{
	input: Types.StakingActionInput;
}>;

export type UnstakeMutation = {
	__typename?: "Mutation";
	unstake:
		| {
				__typename: "StakingAction";
				id: string;
				type: Types.StakingActionType;
				walletId?: string | null;
				assetAmount: { __typename?: "CurrencyAmount"; value: string };
				asset: { __typename?: "StakeableAsset"; assetId: string };
				balanceAfter: { __typename?: "CurrencyAmount"; value: string };
				createdAt: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
		  }
		| { __typename: "StakingActionInProgress"; _?: boolean | null };
};

export const UnstakeDocument = gql`
	mutation unstake($input: StakingActionInput!) {
		unstake(input: $input) {
			__typename
			... on StakingAction {
				id
				assetAmount {
					value
				}
				type
				walletId
				asset {
					assetId
				}
				balanceAfter {
					value
				}
				createdAt {
					iso8601
					unixTimestamp
				}
			}
			... on StakingActionInProgress {
				_
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class UnstakeGQLService extends Apollo.Mutation<UnstakeMutation, UnstakeMutationVariables> {
	document = UnstakeDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
